import { z } from "zod";

/** Org + modal display unit for document PDF qty/weight labels (SC-2494). */
export const DisplayUomSchema = z.enum(["DEFAULT", "LB", "KG"]);
export type DisplayUom = z.infer<typeof DisplayUomSchema>;

export const DocumentDisplayUomSettingsSchema = z.object({
  displayUom: DisplayUomSchema.default("DEFAULT"),
  allowDisplayUomOverrideOnCreate: z.boolean().default(false),
});

export type DocumentDisplayUomSettings = z.infer<typeof DocumentDisplayUomSettingsSchema>;

export const emptyDocumentDisplayUomSettings = (): DocumentDisplayUomSettings => ({
  displayUom: "DEFAULT",
  allowDisplayUomOverrideOnCreate: false,
});

/** Modal PDF display UOM; null/undefined = use org default without an explicit modal choice. */
export const DisplayUomOverrideSchema = DisplayUomSchema.nullish();

export type DisplayUomOverride = z.infer<typeof DisplayUomOverrideSchema>;
